import { render } from "./visitorDashboard.vue?vue&type=template&id=1acdd1ef"
import script from "./visitorDashboard.vue?vue&type=script&lang=js"
export * from "./visitorDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__